export enum CoursePrerequisiteAccessStatusEnum {
  ACCESSIBLE = "accessible",
  BLOCKED = "blocked",
  UNAVAILABLE = "unavailable",
}
